import React from 'react';
import './Header.css'
//import profile from '../../img/pic.png.jpg'
import profile1 from '../../img/coading image.png'
import Typical from 'react-typical';
import Particles from 'react-particles-js';
import download from '../../img/Untitled-4.png'
import {RiBarChartHorizontalFill} from 'react-icons/ri'
import "animate.css"

const Header = () => {
    return (


        


        <div id="header" className="headerStyle row">
             <div style={{ position: 'absolute'}}>
      
      <Particles height="100vh" width="100vw" params={
        
        
        {
          particles:{
            number:{
              value:80,
              density: {
                  enable: true,
                  value_area: 1200,
              }
            },
            color: {
              // value: '#fff'
          },
          opacity: {
            value: 0.05,
            anim: {
                enable: false
            }
          },
          size: {
            value: 7,
            random: true,
            anim: {
                enable: true,
                speed: 3
            }
        },

      
      move: {
          speed: 1.5
      }
        
          }
        }
      } />
    </div>

    <div>
            <nav class="navbar navbar-expand-lg navbar-light navbar-style nav-positioning my-0">
            <span className="bg-light logoSpan"><img className="img-fluid" src="https://img.icons8.com/ios-filled/100/000000/circled-s.png"/></span>
            <div className="ml-auto">
            <button class="navbar-toggler navIcon color-info bg-light" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo03" aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation">
                <span class=" navIcon"> <i><RiBarChartHorizontalFill /></i></span>
            </button>
            </div>
            

            <div class="collapse navbar-collapse ml-auto" id="navbarTogglerDemo03">
                <div className="ml-auto">
                <ul class="navbar-nav mr-auto mt-2  mt-lg-0">
                <li class="nav-item my-2 px-2 mx-2 active button-bg">
                    <a class=" nav-text text-light my-3 text-center font-sizer link-3" href="#header">Home <span class="sr-only">(current)</span></a>
                </li>
                <li class="nav-item my-2 px-2 mx-2 button-bg">
                    <a class="nav-text text-light my-3 text-center font-sizer link-3" href="#about">About</a>
                </li>
                <li class="nav-item my-2 px-2 mx-2 button-bg">
                    <a class=" nav-text text-light my-3 text-center font-sizer link-3" href="#card">Projects</a>
                </li>
                <li class="nav-item my-2 px-2 mx-2 button-bg">
                    <a class=" nav-text text-light my-3 text-center font-sizer link-3" href="#blogs">Blogs</a>
                </li>
                <li class="nav-item my-2 px-2 mx-2 button-bg">
                    <a class=" nav-text text-light my-3 text-center font-sizer link-3" href="#contact">Contact</a>
                </li>
                </ul>
                </div>
                
            </div>
            </nav>
       
        </div>

           
            <div className="col-md-6 d-flex align-items-center justify-content-center">
                <img className="profile-pic w-75 m-5" src={profile1} alt=""/>

            </div>
            
            <div className="col-md-6 d-flex align-items-center justify-content-center ">
                    <h3 className="text-center letter-styling">Hello , I am <br/> <span className="nameColor">Shahin Shah</span> <br/> <br/> 
                        <Typical
                            loop={Infinity}
                            wrapper={"b"}
                            steps={[
                                ' Front-end web developer',
                                2000,
                                ' MERN Stack developer',
                                2000,
                                'Programmer',
                                2000,
                                'Learner',
                                2000
                                
                               

                            ]}
                        />
                        <div>
                             
                              <a className="hiremeBtn animate__bounce" href="https://drive.google.com/uc?export=download&id=1gHbgyft2qfZ_Id8IPaAazdY8i1a3B563"><img src={download} alt=""/></a>

                        </div>
                    </h3>

                   
                   
                    
            </div>


            
            


            




            
                
               

     
            
            
        </div>
        
    );
};

export default Header;